<template>
    <v-container  fluid fill-height class="thankyou mt-5">
        <v-layout flex align-center justify-center>
            <div class="text-xs-center mt-4">
                <v-icon x-large dark color="green" style="font-size: 5em">mdi-check-circle</v-icon>
                <h1 class="font-weight-bold mt-3">บันทึกสำเร็จ</h1>
                <h2>ขอบคุณที่ร่วมประเมิน</h2>

                <v-btn v-if="back_btn" color="info" large dark block class="font-weight-bold mt-4" @click="back_to_emp()">กลับไปหน้าค้นหาพนักงาน</v-btn>

            </div>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "EvaThankyou",
        props:{
            back_btn:Boolean
        },
        methods:{
            back_to_emp(){
                this.$emit('back_to_emp')
            }
        }
    }
</script>

<style scoped>

</style>